import axios from "axios"
import { headersProvider, headersProviderForDetails } from "../pages/utilities";

export const loginUser =async ({email, password})=>{
    return axios.post(`${process.env.REACT_APP_API_URL}/users/sp-login`, { email, password })
    .then(response => response.data)
    .catch(error => {
      console.error("There was an error logging in!", error);
      throw error;
    });
}

export const addUser = async({email, password, enabled, role, businessUnits, name,userRoles}) =>{
  return axios.post(`${process.env.REACT_APP_API_URL}/service-providers/new`, {email, password, enabled, role, businessUnits, name, userRoles},{
    headers: headersProvider(),
  })
    .then(response => response.data)
    .catch(error => {
      console.error("There was an error logging in!", error);
      throw error;
    });
}

export const updateUser = async({userData})=>{
  return axios.put(`${process.env.REACT_APP_API_URL}/edituser/${userData.id}`, { ...userData},{
    headers: headersProvider(),
  })
    .then(response => response.data)
    .catch(error => {
      console.error("There was an error updating user", error);
      throw error;
    });
}


export const addBu = async({name, enabled})=>{
  return axios.post(`${process.env.REACT_APP_API_URL}/addbu`, {name, enabled},{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error =>{
    console.error("There was an error adding bu", error);
    throw error;
  });
}

export const updateBuDetails = async({id, name, enabled})=>{
  return axios.put(`${process.env.REACT_APP_API_URL}/updateBu/${id}`, {name, enabled},{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error =>{
    console.error("There was an error updating bu", error);
    throw error;
  });
}

export const getBuData  = async()=>{
  return axios.get(`${process.env.REACT_APP_API_URL}/getbudata`,{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting bu name", error);
    throw error;
  });
} 

export const getBuList = async ({page}) => {
  return axios.post(`${process.env.REACT_APP_API_URL}/getbulist`, {page},{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting bu list", error);
    throw error;
  });
}

export const getBuName = async({id})=>{
  return axios.get(`${process.env.REACT_APP_API_URL}/getbuname/${id}`,{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting bu name", error);
    throw error;
  });
}


export const getBuDetails = async ({page, id}) => {
  return axios.post(`${process.env.REACT_APP_API_URL}/getbudetails/${id}`, {page},{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting bu list", error);
    throw error;
  });
}

export const getComplianceStatus = async ({filters, page, pageSize, sortOptions}) => {
  return axios.post(`${process.env.REACT_APP_API_URL}/getcomplaincestatus`,{filters, page, pageSize, sortOptions},{
    headers: headersProvider(),
  } )
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting bu list", error);
    throw error;
  });
}
export const fetchBuOptions = async()=>{
  return axios.get(`${process.env.REACT_APP_API_URL}/getbuoptions`,{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting bu options", error);
    throw error;
  });
}

export const fetchRegions = async()=>{
  return axios.get(`${process.env.REACT_APP_API_URL}/getregions`,{
    headers: headersProvider(),
  })
  .then(response=> response.data)
  .catch(error=>{
    console.error("there was an error fetching regions", error);
  })
}
export const getMasterObligation = async({id})=>{
  return axios.get(`${process.env.REACT_APP_API_URL}/getMasterObligation/${id}`,{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting bu options", error);
    throw error;
  });
}

export const deleteObligation = async ({id}) => {
  return axios.post(`${process.env.REACT_APP_API_URL}/deleteMasterObligation/${id}`,{} ,{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting bu list", error);
    throw error;
  });
}

export const pauseObligation = async ({id}) => {
  return axios.post(`${process.env.REACT_APP_API_URL}/pauseMasterObligation/${id}`,{} ,{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting bu list", error);
    throw error;
  });
}
export const getTitlesOfAgreement = async()=>{
  return axios.get(`${process.env.REACT_APP_API_URL}/titlesofagreement`,{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting bu options", error);
    throw error;
  });
}
export const getNamesofAgreement = async()=>{
  return axios.get(`${process.env.REACT_APP_API_URL}/namesofagreement`,{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting bu options", error);
    throw error;
  });
}

export const getStandardObligations = async()=>{
  return axios.get(`${process.env.REACT_APP_API_URL}/getstandardobligations`,{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting bu options", error);
    throw error;
  });
}

export const getDeptUsers = async()=>{
  return axios.get(`${process.env.REACT_APP_API_URL}/getdeptUsers`,{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting dept users", error);
    throw error;
  });
}

export const getUserDetails = async()=>{
  return axios.get(`${process.env.REACT_APP_API_URL}/getUserDetails`,{
    headers: headersProviderForDetails(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting user data", error);
    throw error;
  });
}

export const getDocuments = async({page, pageSize})=>{
  return axios.post(`${process.env.REACT_APP_API_URL}/getdocuments`, {page, pageSize},{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error => {
    console.error("There was an error getting documents data", error);
    throw error;
  });
}
export const changeDepartment = async({department})=>{
  return axios.post(`${process.env.REACT_APP_API_URL}/changeDepartment`, {department},{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error=>{
    console.error("there is an error changing department", error);
    throw error;
  })
}
export const changeUserRole = async({userRole})=>{
  return axios.post(`${process.env.REACT_APP_API_URL}/changeuserrole`, {userRole},{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error=>{
    console.error("there is an error changing user role", error);
    throw error;
  })
}
export const changeBusinessUnit = async({buId})=>{
  return axios.post(`${process.env.REACT_APP_API_URL}/changeBusinessUnit`, {buId},{
    headers: headersProvider(),
  })
  .then(response => response.data)
  .catch(error=>{
    console.error("there is an error changing businessunit", error);
    throw error;
  })
}